var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipContent),expression:"tooltipContent"}],attrs:{"icon":"","small":_vm.small},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"small":_vm.small,"color":_vm.dark ? 'white' : 'grey darken-1'}},[_vm._v("\n    "+_vm._s(_vm.type)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e066c3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utils/RpIcon.vue
// module id = 788
// module chunks = 2